import { render, staticRenderFns } from "./LeakageCauseWorkerWorksBeforeQuestion.vue?vue&type=template&id=5bea3462&scoped=true"
import script from "./LeakageCauseWorkerWorksBeforeQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseWorkerWorksBeforeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea3462",
  null
  
)

export default component.exports